import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const exampleNewsletterPatchReducer: RemoteReducer<string> =
  createRemoteReducer("exampleNewsletterPatch")
